import axios from '../utils/axios';
import qs from 'qs';
/**
 * 获取代理商列表
 * @param params
 * @returns {*}
 */
export async function getAgentList (params) {

  return await axios.GET('/v1/agent/list', params);
}


/**
 * 获取代理商详情
 * @param params
 * @returns {*}
 */
export async function getAgentDetail (params) {

  return await axios.GET('/v1/agent/detail', params);
}

/**
 * 收回卡
 * @param params
 * @returns {*}
 */
export async function shCardRecovery (params) {

  return await axios.POST(`/v1/agent/cardRecovery?` + qs.stringify(params));
}


/**
 * 修改代理商名称
 * @param params
 * @returns {*}
 */
export async function upModifyingAgentInformation (params) {

  return await axios.POST(`/v1/agent/ModifyingAgentInformation?` + qs.stringify(params));
}


/**
 * 修改代理商密码
 * @param params
 * @returns {*}
 */
export async function upAgentPassword (params) {

  return await axios.POST(`/v1/agent/password?` + qs.stringify(params));
}

/**
 * 添加代理商
 * @param params
 * @returns {*}
 */
export async function addAgent (params) {

  return await axios.POST(`/v1/agent/add?` + qs.stringify(params));
}

/**
 * 销售服务卡
 * @param params
 * @returns {*}
 */
export async function sellCard (params) {

  return await axios.POST(`/v1/agent/blance/add?` + qs.stringify(params));
}


/**
 * 获取销售记录
 * @param params
 * @returns {*}
 */
export async function getSalesPurchaseRecord (params) {

  return await axios.GET('/v1/agent/getSalesPurchaseRecord', params);
}

/**
 * 查询代理商点卡开关
 * @param params
 * @returns {*}
 */
export async function queryCardSwitch (params) {

  return await axios.POST(`/v1/agent/queryCardSwitch?` + qs.stringify(params));
}

//修改代理商信息
export async function changeagentinfo (params) {
  return await axios.POST("/v1/agent/updateAgent?" + qs.stringify(params))
}

//设置“第一次修改密码弹窗”值
export async function setPrompt (params) {
  return await axios.POST("/v1/profile/setPrompt?" + params)
}